import { Command } from "./Command";

export default class LinkRideWithGpsCommand extends Command {
    code: string
    constructor(code: string) {
        super()
        this.code = code
    }
}
